import React from "react";
import { Modal, Grid, Button } from "@mui/material";
import RocketImg from "../../../assets/SAP-Dashboard/RocketModal/Rocket.png";
import Cloud1 from "../../../assets/SAP-Dashboard/RocketModal/Cloud1.png";
import Cloud2 from "../../../assets/SAP-Dashboard/RocketModal/Cloud2.png";
import Cloud3 from "../../../assets/SAP-Dashboard/RocketModal/Cloud3.png";
import CloudRight from "../../../assets/SAP-Dashboard/RocketModal/CloudRight.png";
import CloudLeft from "../../../assets/SAP-Dashboard/RocketModal/CloudLeft.png";
import CloudLeftNearRocket from "../../../assets/SAP-Dashboard/RocketModal/CloudLeftNearRocket.png";
import Tick from "../../../assets/SAP-Dashboard/RocketModal/Tick.png";

import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function RocketModal({ open, handleClose, message }) {
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={handleClose}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "100vh",
        }}
      >
        {/* Modal Card */}
        <Grid
          item
          xs={11}
          sm={8}
          md={6}
          lg={5}
          sx={{
            position: "relative",
            bgcolor: "#572575",
            borderRadius: "24px",
            boxShadow: 24,
            overflow: "hidden",
            height: 500,
          }}
        >
          {/* ===== CIRCLE ===== */}
          <Grid
            container
            sx={{
              position: "relative",
              zIndex: 1,
              fontSize: "14px",
            }}
          >
            <motion.svg
              width="276"
              height="229"
              viewBox="0 0 276 229"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              initial={{ scale: 1, y: 0 }}
              animate={
                open ? { scale: 0.6, y: -100, x: -100 } : { scale: 1, y: 0 }
              }
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
            >
              <ellipse
                cx="120.5"
                cy="84.5"
                rx="155.5"
                ry="144.5"
                fill="#7A439C"
              />
            </motion.svg>
          </Grid>
          {/* ===== CLOUDS (each positioned individually) ===== */}
          {/* Left small layered cloud */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: 40,
              left: -80,
            }}
          >
            <motion.img
              src={Cloud1}
              alt="cloud"
              initial={{ scale: 1, y: 0 }}
              animate={open ? { scale: 1, y: 50 } : { scale: 1, y: 0 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 260 }}
            />
          </Grid>
          {/* Left small cloud */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: 1,
              left: -80,
            }}
          >
            <motion.img
              src={CloudLeft}
              alt="cloud"
              initial={{ scale: 1, y: 0 }}
              animate={open ? { scale: 1, y: 50 } : { scale: 1, y: 0 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 260 }}
            />
          </Grid>
          {/* Cloud right near Rocket (mirrored horizontally) */}
          <Grid
            item
            sx={{
              position: "absolute",
              top: 140,
              left: "65%",
              transform: "translateX(-50%) scaleX(-1)",
            }}
          >
            <motion.img
              src={CloudLeftNearRocket}
              alt="cloud"
              initial={{ scale: 1, x: 0 }}
              animate={open ? { scale: 0.5, x: 2 } : { scale: 1 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 199 }}
            />
          </Grid>
          {/* Cloud right near Rocket */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: 170,
              left: "65%",
              transform: "translateX(-50%)",
            }}
          >
            <motion.img
              src={CloudLeftNearRocket}
              alt="cloud"
              initial={{ scale: 1 }}
              animate={open ? { scale: 0.5 } : { scale: 1 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 220 }}
            />
          </Grid>
          {/* Cloud left near Rocket */}
          <Grid
            item
            sx={{
              position: "absolute",
              top: 210,
              left: "25%",
              transform: "translateX(-50%)",
            }}
          >
            <motion.img
              src={CloudLeftNearRocket}
              alt="cloud"
              initial={{ scale: 1 }}
              animate={open ? { scale: 0.5 } : { scale: 1 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 220 }}
            />
          </Grid>
          {/* ===== CONTENT AFTER ROCKET ===== */}
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
              position: "absolute",
              top: "40%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              color: "white",
              zIndex: 20,
            }}
          >
            {/* Tick Icon */}
            <motion.img
              src={Tick}
              alt="Success"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={
                open ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
              }
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.5 }} // Delay added
              style={{ width: 70, marginBottom: 35 }}
            />

            {/* Heading */}
            <motion.h2
              initial={{ opacity: 0, scale: 0.8 }}
              animate={
                open ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
              }
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.5 }}
              style={{
                fontSize: "22px",
                fontFamily: "Lato",
                fontWeight: "800",
                marginBottom: 20,
              }}
            >
              Quiz complete!
            </motion.h2>

            {/* Subheading */}
            <motion.p
              initial={{ opacity: 0, scale: 0.8 }}
              animate={
                open ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
              }
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.5 }}
              style={{
                margin: "8px 0 0 0",
                fontSize: "14px",
                color: "#ddd",
                maxWidth: 320,
                fontFamily: "Lato",
                fontWeight: 700,
              }}
            >
              {message}
            </motion.p>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={
                open ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
              }
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.5 }}
            >
              <Grid container justifyContent="center" spacing={2} mt={2}>
                <Grid item>
                  <Button
                    variant="outlined"
                    sx={{
                      borderRadius: "8px",
                      borderColor: "#fff",
                      color: "#fff",
                      px: 3,
                      py: 1,
                      textTransform: "none",
                      fontWeight: "bold",
                      "&:hover": {
                        borderColor: "#fff",
                        backgroundColor: "rgba(255,255,255,0.1)",
                      },
                    }}
                    onClick={() => navigate("/sap/timeline")}
                  >
                    Back to dashboard
                  </Button>
                </Grid>

                {/* <Grid item>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                      color: "#572575",
                      px: 3,
                      py: 1,
                      textTransform: "none",
                      fontWeight: "bold",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                    // onClick={() => navigate("/sap/next-step")}
                  >
                    Go to next Step
                  </Button>
                </Grid> */}
              </Grid>
            </motion.div>
          </Grid>

          {/* ===== STARS near Rocket ===== */}
          <Grid>
            {/* Star 1 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 120,
                left: "40%",
                color: "white",
                fontSize: "12px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: -40, y: -30, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 2 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 150,
                left: "70%",
                color: "white",
                fontSize: "10px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: 40, y: -20, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 3 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 200,
                left: "45%",
                color: "white",
                fontSize: "14px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: -80, y: 60, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 4 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 240,
                left: "60%",
                color: "white",
                fontSize: "11px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: 70, y: 70, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 5 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 100,
                left: "55%",
                color: "white",
                fontSize: "9px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: 50, y: -40, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 6 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 180,
                left: "35%",
                color: "white",
                fontSize: "8px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: -60, y: 40, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 7 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 220,
                left: "75%",
                color: "white",
                fontSize: "13px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: 90, y: 50, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 8 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 260,
                left: "48%",
                color: "white",
                fontSize: "7px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: -40, y: 100, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 9 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 280,
                left: "65%",
                color: "white",
                fontSize: "12px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: 70, y: 90, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>

            {/* Star 10 */}
            <Grid
              item
              sx={{
                position: "absolute",
                top: 140,
                left: "30%",
                color: "white",
                fontSize: "10px",
              }}
            >
              <motion.div
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={
                  open
                    ? { x: -100, y: -50, opacity: 0.8 }
                    : { x: 0, y: 0, opacity: 1 }
                }
                transition={{ duration: 2, ease: "easeInOut" }}
              >
                ✦
              </motion.div>
            </Grid>
          </Grid>

          {/* Middle layered cloud */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: 40,
              left: "57%",
            }}
          >
            <motion.img
              src={Cloud3}
              alt="cloud"
              initial={{ scale: 1, y: 0 }}
              animate={open ? { scale: 1, y: 50 } : { scale: 1, y: 0 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 280 }}
            />
          </Grid>
          {/* Right bottom big fluffy cloud */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: 50,
              right: -3,
            }}
          >
            <motion.img
              src={CloudRight}
              alt="cloud"
              initial={{ scale: 1, y: 0 }}
              animate={open ? { scale: 1, y: 75 } : { scale: 1, y: 0 }}
              transition={{
                duration: 2, // synced with rocket, circle, Cloud2
                ease: "easeInOut",
              }}
              style={{ width: 220 }}
            />
          </Grid>
          {/* Big center wide cloud (background layer) */}
          <Grid
            item
            sx={{
              position: "absolute",
              bottom: -10,
            }}
          >
            <motion.img
              src={Cloud2}
              alt="cloud"
              initial={{ scale: 1, y: 0 }}
              animate={open ? { scale: 1, y: 50, x: 10 } : { scale: 1, y: 0 }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
              style={{ width: 850 }}
            />
          </Grid>
          {/* ===== ROCKET ===== */}
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              position: "absolute",
              bottom: 2,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
            }}
          >
            <motion.img
              src={RocketImg}
              alt="Rocket"
              initial={{ y: 0, opacity: 1 }}
              animate={open ? { y: -600, opacity: 0 } : { y: 0, opacity: 1 }}
              transition={{
                duration: 2, // Speed of launch
                ease: "easeInOut",
              }}
              style={{ width: 240, height: 300 }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
